import { render, staticRenderFns } from "./projectUpdateDialog.vue?vue&type=template&id=0cf9dd6c"
import script from "./projectUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./projectUpdateDialog.vue?vue&type=script&lang=ts"
import style0 from "./projectUpdateDialog.vue?vue&type=style&index=0&id=0cf9dd6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports